<template>
  <div class="old-globals">
    <md-card class="gray-1 bg">
      <md-progress-bar v-if="loading" md-mode="query" />
      <md-card-header>
        <div class="md-layout md-alignment-center-center header-content">
          <img class="logo" alt="VRpatients Logo" src="../../../assets/images/VRP_Logo.png" />
        </div>
      </md-card-header>
      <md-card-content v-if="!emailSent">
        <div v-if="error" class="form-error">{{ error.message }}</div>
        <md-field>
          <md-input v-model.trim="state.email" placeholder="Email" />
        </md-field>
      </md-card-content>    
      <md-card-content v-if="emailSent">
        A password reset email has been sent. Please follow the link in that email to change your password.
      </md-card-content>
      <md-card-actions md-alignment="space-between">
        <router-link to="login">Sign in</router-link>
        <md-button v-if="!emailSent" class="md-raised md-primary" @click="resetPassword">Reset Password</md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "ResetPasswordForm",
  props: {
    loading: { type: Boolean, required: true },
    error: { type: Error, default: null },
    emailSent: { type: Boolean, default: false },
  },
  data: function(){
    return {
      state: {
        email: '',
      },
    }
  },
  methods: {
    resetPassword() {
      this.$emit("resetPassword", this.state.email);
    }
  }
};
</script>

<style>
.header-content {
  flex-direction: column;
}
.logo {
  max-width: 100px;
}
</style>
